import { useQueryClient } from '@tanstack/react-query'
import { useRealtime } from '@/lib/ws/useRealtime'

export function DemosRealtime() {
  const qc = useQueryClient()
  useRealtime(
    (event) => event.startsWith('demo.'),
    () => {
      void qc.invalidateQueries({ queryKey: ['demos'] })
    },
  )
  return null
}
